import React from "react";
import Button from "./ui/Button";

interface ConfirmationButtonsProps {
  handleConfirm: () => void;
  handleCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  disabled?: boolean;
  isLoading: boolean;
}

const ConfirmationButtons: React.FC<ConfirmationButtonsProps> = ({
  handleCancel,
  handleConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  disabled = false,
  isLoading,
}) => {
  return (
    <div className={`flex justify-end gap-4 w-full py-4 px-4 sticky bottom-0 bg-white rounded-llg`}>
      <Button variant="secondary" size="small" onClick={handleCancel} className="">
        {cancelText}
      </Button>
      <Button variant="primary" size="small" onClick={handleConfirm} disabled={disabled} className="" isLoading={isLoading}>
        {confirmText}
      </Button>
    </div>
  );
};

export default ConfirmationButtons;
